module.exports = __webpack_public_path__ + "img/noirepayskrill.4e35aa60.svg";